import type { Campaign } from '~/types/graphql';

import { CAMPAIGN_STATUS } from '~/constants/campaign';

type TextToneType = 'caution' | 'critical' | 'success' | 'subdued';
type BadgeToneType = 'warning' | 'critical' | 'success' | 'new';
type GetCampaignStatusInfoType = (status: Campaign['status']) => {
  name: string;
  tone?: TextToneType;
  badgeTone?: BadgeToneType;
  customColor?: string;
};

export const getCampaignStatusInfo: GetCampaignStatusInfoType = (status) => {
  switch (status) {
    case CAMPAIGN_STATUS.PAUSED:
      return {
        name: 'Paused',
        tone: 'critical',
        badgeTone: 'critical',
        customColor: '#8E1F0B',
      };
    case CAMPAIGN_STATUS.RUNNING:
      return {
        name: 'Live',
        tone: 'success',
        badgeTone: 'success',
        customColor: '#29845A',
      };
    case CAMPAIGN_STATUS.COMPLETED:
    case CAMPAIGN_STATUS.STOPPED:
      return {
        name: 'Ended',
        tone: 'subdued',
        badgeTone: 'new',
        customColor: '#8E1F0B',
      };
    default:
      return {
        name: 'Draft',
        tone: 'caution',
        customColor: '#AB862B',
        badgeTone: 'warning',
      };
  }
};
